<template>
  <section class="leads">
    <Breadcrumb :links="links" />
    <div v-if="hasLeads" class="leads__itens">
      <div class="leads__header">
        <h2>Leads Empresas</h2>
        <input
          class="search"
          type="text"
          placeholder="Buscar empresa..."
          @input="handleSearchCompany"
        />
      </div>
      <div class="leads__div">
        <table class="leads__table">
          <thead>
            <tr>
              <th>Empresa</th>
              <th>Responsável</th>
              <th>Email</th>
              <th>N° Whatsapp</th>
              <th>Preferência de contato</th>
              <th>Mensagem</th>
              <th>Cargo</th>
              <th>Departamento</th>
              <th>N° colaboradores</th>
              <th>Data e horário</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="lead in leads"
              :key="lead.id"
              @click="handleClickViewDetails(lead)"
            >
              <template v-if="filterLead(lead.company)">
                <td>{{ lead.company }}</td>
                <td>{{ lead.name }}</td>
                <td>{{ lead.email }}</td>
                <td>{{ lead.number_whats_app }}</td>
                <td>{{ lead.type_contact }}</td>
                <td>{{ lead.message }}</td>
                <td>{{ lead.position_name }}</td>
                <td>{{ lead.department_name }}</td>
                <td>{{ lead.number_of_collaborators }}</td>
                <td>{{ lead.created_at | dateTimeFormat }}</td>
                <td>
                  <span
                    class="badge"
                    :class="getClassStatusLead(lead.id_lead_status)"
                  >
                    {{ lead.lead_status }}
                  </span>
                  <div class="actions">
                    <button class="btn btn-secondary">Ver detalhes</button>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <ModalLeadDetails
        :lead="leadViewDetails"
        :class-status-lead="getClassStatusLead(leadViewDetails.id_lead_status)"
      />
    </div>
    <NotData v-else :text="'Nenhum lead registrado.'" />
  </section>
</template>
<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import NotData from "@/components/notData/Index";
import ModalLeadDetails from "@/views/Company/components/ModalLeadDetails";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Breadcrumb,
    NotData,
    ModalLeadDetails,
  },
  computed: {
    ...mapGetters("Company", ["leads"]),
    filterLead() {
      return (company) => {
        return (
          !this.searchCompany ||
          company.toLowerCase().indexOf(this.searchCompany) !== -1
        );
      };
    },
    hasLeads() {
      return Array.isArray(this.leads) && this.leads.length > 0;
    },
    getClassStatusLead() {
      return (leadStatus) => {
        if (leadStatus === 2) {
          return "status-tentative";
        }

        if (leadStatus === 3) {
          return "status-in-progress";
        }

        if (leadStatus === 4) {
          return "status-qualified";
        }

        if (leadStatus === 5) {
          return "status-not-qualified";
        }

        return "status-new";
      };
    },
  },
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Leads",
          routerName: "Leads",
        },
      ],
      searchCompany: null,
      leadViewDetails: {},
    };
  },
  methods: {
    ...mapActions("Company", ["consultLeads"]),
    handleSearchCompany($event) {
      this.searchCompany = $event.target.value.toLowerCase();
    },
    handleClickViewDetails(lead) {
      this.leadViewDetails = lead;
      this.$bvModal.show("modal-lead-details");
    },
  },
  async mounted() {
    await this.consultLeads();
  },
};
</script>
<style lang="scss" scoped>
.leads {
  &__itens {
    padding: 30px 20px;
    background: var(--white);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    @media (max-width: 991px) {
      flex-direction: column;
      align-items: flex-start;
    }
    h2 {
      font-size: 20px;
      font-family: "Font Bold";
      color: var(--black);
    }
    input {
      padding: 10px 14px;
      border-radius: 8px;
      border: 1px solid var(--gray-light);
      width: 100%;
      max-width: 300px;
      font-size: 16px;
      color: var(--gray-dark);
      font-family: "Font Regular";
    }
  }
  &__div {
    overflow-x: auto;
  }
  &__table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1200px;
    thead {
      background: var(--yellow-2);
      color: var(--black);
    }
    th {
      padding: 14px 16px;
      text-align: left;
      font-size: 14px;
      font-family: "Font Bold";
      color: var(--black);
    }
    td {
      padding: 14px 16px;
      text-align: left;
      font-size: 14px;
      font-family: "Font Regular";
      color: var(--gray-dark);
    }
    th {
      font-weight: 600;
      text-transform: uppercase;
      font-size: 12px;
      letter-spacing: 0.5px;
    }
    tbody tr {
      border-bottom: 1px solid var(--gray-light);
      transition: background 0.2s;
    }
    tbody tr:hover {
      background: #f1f5f9;
      cursor: pointer;
    }
    .badge {
      padding: 6px 10px;
      border-radius: 999px;
      font-size: 12px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .btn {
      border: none;
      padding: 6px 10px;
      border-radius: 6px;
      font-size: 12px;
      font-family: "Font Bold";
      cursor: pointer;
      min-width: 100px;
    }
    .btn-primary {
      background: #22c55e;
      color: white;
    }
    .btn-primary:hover {
      background: #16a34a;
    }
    .btn-secondary {
      background: #3b82f6;
      color: white;
    }
    .btn-secondary:hover {
      background: #2563eb;
    }
    .status-new {
      background: #e2e8f0;
      color: #334155;
    }
    .status-tentative {
      background: #fef3c7;
      color: #92400e;
    }
    .status-in-progress {
      background: #dbeafe;
      color: #1e40af;
    }
    .status-qualified {
      background: #dcfce7;
      color: #166534;
    }
    .status-not-qualified {
      background: #fee2e2;
      color: #991b1b;
    }
  }
}
</style>
